var render = function render(_c,_vm){return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.listeners.click()}}},[_c('path',{attrs:{"d":"M8 16l7-5-7-5v10z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }